import { render, staticRenderFns } from "./ThgVehicleTableLegendDialog.vue?vue&type=template&id=1801780c"
import script from "./ThgVehicleTableLegendDialog.vue?vue&type=script&lang=ts"
export * from "./ThgVehicleTableLegendDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports